import React from 'react';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { getColor, getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MentionListWrapper = styled.div.withConfig({
  displayName: "mention-listcontainer__MentionListWrapper",
  componentId: "sc-39xrff-0"
})(["display:flex;flex-wrap:wrap;gap:", ";padding:", " ", ";background-color:", ";gap:8px;padding:12px 16px;"], getSize('padding8'), getSize('padding12'), getSize('padding16'), getColor('fillBgWhite'));

var getTagColor = function getTagColor(type, theme) {
  return {
    bg: '#e6f4ff',
    border: 'transparent',
    text: '#0958d9'
  };
};

var MentionTag = styled.button.withConfig({
  displayName: "mention-listcontainer__MentionTag",
  componentId: "sc-39xrff-1"
})(["display:inline-flex;align-items:center;gap:", ";padding:8px 12px;", " border-radius:20px;font-size:13px;font-weight:500;cursor:pointer;transition:all 0.2s ease;outline:none;&:hover{filter:brightness(0.98);background-color:#bae0ff;}"], getSize('padding4'), function (_ref) {
  var $type = _ref.$type,
      theme = _ref.theme;

  var _getTagColor = getTagColor($type, theme),
      bg = _getTagColor.bg,
      border = _getTagColor.border,
      text = _getTagColor.text;

  return "\n      background-color: ".concat(bg, ";\n      border: 1px solid ").concat(border, ";\n      color: ").concat(text, ";\n    ");
});
var RemoveButton = styled.button.withConfig({
  displayName: "mention-listcontainer__RemoveButton",
  componentId: "sc-39xrff-2"
})(["display:inline-flex;align-items:center;justify-content:center;width:14px;height:14px;padding:0;margin-left:", ";border:none;border-radius:50%;background:transparent;color:", ";font-size:8px;cursor:pointer;transition:all 0.2s ease;flex-shrink:0;opacity:0.6;&:hover{opacity:1;background-color:rgba(0,0,0,0.05);}.anticon{font-size:8px;color:inherit;}"], getSize('padding4'), function (_ref2) {
  var $type = _ref2.$type,
      theme = _ref2.theme;
  return getTagColor($type, theme).text;
});
export var MentionListContainer = function MentionListContainer(_ref3) {
  var mentions = _ref3.mentions,
      _onClick = _ref3.onClick,
      onRemoveMention = _ref3.onRemoveMention;

  if (!mentions || mentions.length === 0) {
    return null;
  }

  var handleRemove = function handleRemove(item, e) {
    e.stopPropagation();

    if (onRemoveMention) {
      onRemoveMention(item.id);
    }
  };

  return /*#__PURE__*/_jsx(MentionListWrapper, {
    children: mentions.map(function (item) {
      return /*#__PURE__*/_jsxs(MentionTag, {
        onClick: function onClick() {
          return _onClick === null || _onClick === void 0 ? void 0 : _onClick(item);
        },
        $type: item.type,
        children: ["@", item.label.replace(/^@/, ''), /*#__PURE__*/_jsx(RemoveButton, {
          type: "button",
          onClick: function onClick(e) {
            return handleRemove(item, e);
          },
          "aria-label": "Remove ".concat(item.label),
          $type: item.type,
          children: /*#__PURE__*/_jsx(CloseOutlined, {})
        })]
      }, item.id);
    })
  });
};